import styled from 'styled-components'

interface FooterProps {
  background?: string
  justify?: string
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  border-radius: 0.5rem;
  hr {
    width: 97%;
  }
`

export const Footer = styled.footer<FooterProps>`
  width: 100%;
  gap: 2rem;
  background-color: ${(props) => props.background};
  justify-content: ${(props) => props.justify};
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row;
  > div {
    align-self: flex-end;
  }
`
